import event from './permissionEvent'
import permissionMenu from './permission-menu'
import permissionResource from './permission-resource'

export default {
    namespaced: true,
    modules: {
        "event": event,
        "permission-menu": permissionMenu,
        "permission-resource":permissionResource
    }
}
